import { defineComponent as _defineComponent } from 'vue'
import type { BecauseYouLikedModuleFragment } from '@/features/onboarded-home/types';

import HorizontalTitleList from '@/components/timeline/HorizontalTitleList.vue';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BecauseYouLikedModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: BecauseYouLikedModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



useProvideClickoutPlacement('discovery_classic_module');

const sourceTitleBackdropUrlCss = computed(() => {
	const backdropUrl = props.moduleData.likedTitle.content.backdrops[0].backdropUrl
		.replace('{profile}', 's1920')
		.replace('{format}', 'webp');

	return `url(${JW_CONFIG.IMAGESCALER_FAST_URL}${backdropUrl})`;
});

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	titleSize: () => props.moduleData.titles.length,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, sourceTitleBackdropUrlCss, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, HorizontalTitleList }
}

})